import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: 'flex-1',
  host: tv({ base: 'w-fit' }),
  box: tv({
    base: 'flex h-[2.2rem] w-[2.2rem] items-center justify-center rounded-full bg-accentPrimary20',
    variants: {
      checked: {
        true: 'bg-accentPrimary40',
      },
      disabled: { true: 'bg-neutral30' },
    },
  }),
  innerBox: 'w-[1rem] h-[1rem] bg-neutral10 rounded-full',
  content: 'ml-[3rem]',
};
